// extracted by mini-css-extract-plugin
export default {"container":"header_container__nteTq","backArrowIcon":"header_backArrowIcon__bidxQ","header":"header_header__Te31k"};